<template>
  <div class="login-wrap">
    <div class="login">
      <img src="@/assets/logo.svg" class="login__logo" alt="" srcset="" />
      <el-form
        class="login-form"
        ref="ruleFormRef"
        :model="form"
        :rules="rules"
        label-width="120px"
        status-icon
        label-position="top"
      >
        <el-form-item label="Login" prop="email">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input v-model="form.password" type="password" />
        </el-form-item>
        <el-button type="success" @click="submitForm()" :loading="loading">
          Sign in
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import ApiAuth from "@/api/auth";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      form: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          { required: true, message: "Please input Login", trigger: "blur" },
          { type: "email", message: "Email is incorrect", trigger: "blur" },
        ],
        password: [
          { required: true, message: "Please input Login", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("User", ["setUser"]),
    submitForm() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          this.loading = true;
          ApiAuth.login(this.form).then((responce) => {
            if (responce.status) {
              localStorage.setItem("token", responce.data.token);
              this.setUser(responce.data.user);
              this.$router.push("/profile");
            } else {
              this.loading = false;
              this.$notify({
                title: "Error",
                message: "User not found",
                type: "error",
              });
            }
          });
        } else {
          this.$notify({
            title: "Error",
            message: "Form data is invalid",
            type: "error",
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 40%;
  &-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login__logo {
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
  }
}

@media only screen and (max-width: 768px) {
  .login {
    width: 85%;
  }
}
</style>